// extracted by mini-css-extract-plugin
module.exports = {"waveTop":"HighlightCollection_waveTop__YHz6q","waveBottom":"HighlightCollection_waveBottom__mUODW"};